<template>
  <div class="DataTableFilteredOnApiRequestsComponent  DataTables">
    
    <p>{{lang.infotext_2}}:</p>
    <div :id="id">
      <LoaderComponent  v-if="!isData"></LoaderComponent>
    </div>
    <ContextMenuComponent v-if="isPlugin" :menu="menuPlugin" :id="name"></ContextMenuComponent>
    <ContextMenuComponent v-if="!isPlugin" :menu="menu" :id="name"></ContextMenuComponent>
    <br>
 </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

var $ = require('jquery');
var jQuery = $
window.$ = $
window.jQuery = $
var jquery = $;

import * as Tools from '@/Tools/Tools';
import dt from 'datatables.net-bs4';
import LibraryTypes from '@/constants/LibraryTypes'
import PartPropertiesType from '@/constants/PartPropertiesType'



require("datatables.net-select-bs4");
require("datatables.net-keytable");
require("datatables.net-buttons-bs4");
require("@/components/shared/DataTables/jszip.min.js");
var pdfMake = require("pdfmake/build/pdfmake");
var pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

require("@/components/shared/DataTables/buttons.html5.min.js");
require("@/components/shared/DataTables/buttons.print.min.js");
require("@/components/shared/DataTables/buttons.colVis.min.js");

import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'
import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'

import LoaderComponent from "@/components/shared/LoaderComponent"
import ContextMenuComponent from "@/components/shared/ContextMenuComponent"
import { mapGetters } from 'vuex'
export default {
  name: 'DataTableFilteredOnApiRequestsComponent',
  props:{
    lang: Object
  },
  components: {
    LoaderComponent,
    ContextMenuComponent

  },
  data () {
      return {
        name: "DataTableFilteredOnApiRequestsComponent",
        id: "tableplace_" + this._uid,
        columns: [],
        colsAssign: [],
        activeActionIds: [],
        contextMenu: {},
        //list of items in the context menu:
        menu: [
          //{id: "Details", text: this.lang.contextmenu_text_Details},
          
        ],
                
        lengthMenu: 20,
      }
  },
  computed: {
    ...mapGetters({
      appConf: 'appConf',
      isPlugin: "isPlugin"

    }),
    categoryId(){
      if (this.$store.getters.selectedTreeLibraryItemObject == undefined){
        return 1;
      }else{
        return this.$store.getters.selectedTreeLibraryItemObject.categoryId;
      }
    },
    selectedTreeLibraryItemObject(){

      return this.$store.getters.selectedTreeLibraryItemObject
    },
    activeActions(){

      return this.$store.getters.rm_activeActions
    },
    isData(){

      return false
    },
    /*server(){

      return this.$store.getters.server;
    },*/
    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    }

  },
  created () {
    this.activeActionIds = [];
    
    for (let i = 0, lei = this.activeActions.length; i < lei; i++){
      
      const obj = {
        actionId: this.activeActions[i].actionId
      }
      this.activeActionIds.push(obj);
    }
    
  },
  watch: {
    categoryId: function(){
      
      this.getProperties();
    },
    activeActions: {
      handler: function(){

        this.activeActionIds = [];
        for (let i = 0, lei = this.activeActions.length; i < lei; i++){
          
          const obj = {
            actionId: this.activeActions[i].actionId
          }
          this.activeActionIds.push(obj);
        }
        

       
        this.getProperties();
      },
      deep: true
    },
    reloadedAfterActionComplex: {
      handler: function (newValue) {

        for (let el in newValue) {
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {

              this.getProperties();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
    

  },
  updated() {

  },
  mounted: function () {
    
    this.getProperties();


  },
  methods: {
    getProperties() {

      
      let reloadObj = {
        status: true,
        name: "Refresh"
      }
      this.$store.dispatch("reloadAfterActionComplex", reloadObj);
      
      let vue = this;

      

      vue.buildColumns();

    },
    

    buildColumns(properties){
      this.columns = [
          {
            name: "Id",
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_Image,
            alignInColumn: "left",
            propertyId: "",
            type: "image"
          },
          {
            name: this.lang.header_RequestNumber,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_Manufacturer,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_ManufacturerPartNumber,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_PartNumber,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
        },
          {
            name: this.lang.header_LibraryNumber,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_PartRequestNumber,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_Deadline,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_Type,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_Priority,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_Stage,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_Owner,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          {
            name: this.lang.header_CreateDate,
            alignInColumn: "left",
            propertyId: "",
            type: "text"
          },
          
          
        ];

      this.colsAssign = [
        
        { "data": "col___requestId" },
        { "data": "col___image" },
        { "data": "col___requestNumber" },
        { "data": "col___manufacturer" },
        { "data": "col___manufacturerPartNumber" },
        { "data": "col___partNumber" },
        { "data": "col___libraryNumber" },
        { "data": "col___partRequestNumber" },
        { "data": "col___deadLine" },
        { "data": "col___type" },
        { "data": "col___priority" },
        { "data": "col___stage" },
        { "data": "col___owner" },
        { "data": "col___creationDate" },
    
      ]
      
      

      this.buildTable();
    },


    buildTable(){
      

      //let lengthMenu = 20;

      
      this.$store.commit("DELETEALLREQUESTSELECTEDROWS");
      if (this.$store.getters.outerData != true){
        
        
        this.$store.dispatch("setOuterData", false);
      }
      
      var tableplace = document.getElementById("tableplace_"+this._uid);
      if (tableplace == null) {
        return;
      }
      while (tableplace.firstChild) {
          tableplace.removeChild(tableplace.firstChild);
      }

      var place = document.createElement("table");
      place.setAttribute("id", "place"+this._uid);
      place.setAttribute("class", "table table-striped table-bordered");
      place.setAttribute("style", "width:100%;");
      tableplace.appendChild(place)

      var tr1 = document.createElement("tr");
      tr1.setAttribute("class", "cellHeader");
      var thead = document.createElement("thead");
      thead.appendChild(tr1);
      place.appendChild(thead);

      var tr2 = document.createElement("tr");
      tr2.setAttribute("class", "cellFooter");
      var tfoot = document.createElement("tfoot");
      tfoot.appendChild(tr2);
      place.appendChild(tfoot);



      var columnDefs = [];


      let _vue = this;

      var len = this.columns.length;

      let y = 0;

      for (let i = 0; i < len; i++){

        let el = {
          targets: i,
          className: '_dt-body-'+ _vue.columns[i].alignInColumn,
          render: function ( data, type, row, meta ) {
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            
            if (data.value.display != undefined) {
              data.value.display = $.fn.dataTable.render.text().display(data.value.display);
            }

            if (meta.col == 0){
              
              return data.value.display;
              

            }

            let toDisplay = "";
            if (data == undefined){
              
              data = {
                value: {
                  display: "<span style='color:red'>! " + meta.col + "-" + meta.row + "</span"
                }
              }
            }
            
            
            if (data.value != null) {
              if (data.value.display == null) {
                toDisplay = "";
              } else {
                toDisplay = data.value.display;
              }
                
            
            }

            if (meta.col == 1){
            
              let image = "";
              if (row.col___type.type == "part"){
                image = "<img id=\"image__"+data.requestId+"\" class=\"image-svg\" src=\"/static/default.svg\" class=\"image-category\">";
              } else {
                if (row.col___type.libraryType == "default"){
                  image = "<img id=\"image__"+data.revisionId+"\" class=\"image-svg\" src=\"/static/default.svg\" class=\"image-category\">";
                } else if (row.col___type.libraryType == LibraryTypes.PART || row.col___type.libraryType == LibraryTypes.SYMBOL){
                  image = "<img id=\"image__" + data.revisionId + "\" class=\"image-svg\" src=\"/static/symbol.svg\" class=\"image-category\">";
                } else if (row.col___type.libraryType == LibraryTypes.HDLSYMBOL) {
                  image = "<img id=\"image__" + data.revisionId + "\" class=\"image-svg\" src=\"/static/hdl_symbol.svg\" class=\"image-category\">";
                } else if (row.col___type.libraryType == PartPropertiesType.FOOTPRINT){
                  image = "<img id=\"image__"+data.revisionId+"\" class=\"image-svg\" src=\"/static/footprint.svg\" class=\"image-category\">";
                } else if (row.col___type.libraryType == LibraryTypes.MECHANICAL){
                  image = "<img id=\"image__"+data.revisionId+"\" class=\"image-svg\" src=\"/static/mechanical.svg\" class=\"image-category\">";  
                } else if (row.col___type.libraryType == LibraryTypes.PADSTACK){
                  image = "<img id=\"image__"+data.revisionId+"\" class=\"image-svg\" src=\"/static/padstack.svg\" class=\"image-category\">";    
                } else if (row.col___type.libraryType == LibraryTypes.SHAPE){
                  image = "<img id=\"image__"+data.revisionId+"\" class=\"image-svg\" src=\"/static/shape.svg\" class=\"image-category\">";
                } else if (row.col___type.libraryType == LibraryTypes.FLASH){
                  image = "<img id=\"image__" + data.revisionId + "\" class=\"image-svg\" src=\"/static/flash.svg\" class=\"image-category\">";   
                } else if (row.col___type.libraryType == LibraryTypes.FORMAT) {
                  image = "<img id=\"image__" + data.revisionId + "\" class=\"image-svg\" src=\"/static/format.svg\" class=\"image-category\">";   
                } else if (row.col___type.libraryType == LibraryTypes.REUSEMODULE) {
                  image = "<img id=\"image__" + data.revisionId + "\" class=\"image-svg\" src=\"/static/module.svg\" class=\"image-category\">"; 
                } else if (row.col___type.libraryType == LibraryTypes.COM) {
                  image = "<img id=\"image__" + data.revisionId + "\" class=\"image-svg\" src=\"/static/com.svg\" class=\"image-category\">";     
                } else if (row.col___type.libraryType == LibraryTypes.FILE) {
                  image = "<img id=\"image__" + data.revisionId + "\" class=\"image-svg\" src=\"/static/other.svg\" class=\"image-category\">"; 
                }
                
              }
                  
                  
              return image;
                
            }
            if (meta.col == 8) {
                         
              toDisplay = Tools.longDateToShort(data.value.display, false);
              
            }
            if (meta.col == 9) {
              let type = data.value.display;
              if (type == "part") {
                toDisplay = type;
              }
              if (type != "part") {
                toDisplay = "lib (" + row.col___type.libraryType + ")";
              }
              
            }
            
            if (meta.col == 10){
                              
              let status = "";
              let variant = "";
              if (data.value.display == "High") {
                variant = "danger";
              }
              if (data.value.display == "Normal") {
                variant = "info";
              }
              if (data.value.display == "Low") {
                variant = "success";
              }
              status += "<b-badge class='badge badge-"+variant+" '>"+toDisplay+" </b-badge>";
              
              return "<div class=\"badges\">"+status+"</div>";
              
            }
                       
            
            if (meta.col == 11) {

              let status = data.value.display;
              let progress = row.col___stage.progress;
              
              let variantProgress = "success";
              if (progress < 30) {
                variantProgress = "warning";
              }
              if (progress >= 30 && progress < 70) {
                variantProgress = "info"
              }
              let str = "<div class=\"progress\" style=\"height: 5px;\"><div role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" aria-valuenow=\""+progress+"\" class=\"progress-bar bg-"+variantProgress+"\" style=\"width: "+progress+"%;\"></div></div>";

              toDisplay = status + "<br>" + str;
            }
            if (meta.col == 13) {
                         
              toDisplay = Tools.longDateToShort(data.value.display, true);
              
            }
            
             
            return  toDisplay;
            

  
          }
        }



      columnDefs.push(el);




        var th1 = document.createElement("th");
        
        tr1.appendChild(th1);
        
        var br = document.createElement("br");
        var tx = document.createTextNode(this.columns[i].name);
        th1.appendChild(br);
        th1.appendChild(tx);

      }

        let vue = this;


      var option = {};


      option.keys = false;
      //json.data= datatable;
      option.myColumnFormats = this.columns;
      option.colReorder = false;
      option.lengthMenu = [[20, -1], [20, "All"]];
      option.order = [[ 2, "asc" ]];
      option.select = true;
      option.columns = this.colsAssign;
      option.columnDefs = columnDefs;
      
      option.dom = '<fBlr<t>ip>';
      
      
      option.processing= true;
      option.serverSide= true;
      // option.search = {
      //   regex: true
      // }
      option.initComplete = function (settings, json) {
        

        this.api().columns().every( function () {
          var column = this;

          if (vue.columns[column[0][0]].type != "image"){
            var select = $('<select><option value=""></option></select>')
              .appendTo( $(column.footer()).empty() )
              .on( 'change', function () {

                  var val = $.fn.dataTable.util.escapeRegex(
                      $(this).val()
                  );

                  column
                      .search( val ? val : '', true, false )
                      .draw();
              } );
            let arr = [];
            column.data().unique().sort().each( function ( d, j ) {
              if (d == null){
                return
              }
              
              if (d.value.display != null){

                //if (!arr.includes(d.value.display)){
                  arr.push(d.value.display);
                  select.append( '<option value="' + d.value.display + '">' + d.value.display + '</option>' );
                //}

              }


            });
          }

        });


        
      }
      option.fnDrawCallback = function( oSettings ) {
        
        vue.buildContextMenu();
      }
      option.buttons = [
        {
          extend: 'copy',
          className: 'btn-' + vue.variant,
          exportOptions: {
              columns: ':visible'
          }
        },
        {
          extend: 'print',
          className: 'btn-' + vue.variant,
          messageTop: function () {
            return vue.lang.export_label_top + ": " + vue.$store.getters.selectedTreeLibraryItemObject.category;
          },
          exportOptions: {
            columns: ':visible'
          },
          autoPrint: true,
          style: 'fullWidth',
          
          customize: function ( win ) {
              $(win.document.body)
                  .css( 'font-size', '10pt' )
                  

              $(win.document.body).find( 'table' )
                  .addClass( 'compact' )
                  .css( 'font-size', 'inherit' );
          }
        },
        {
          extend: 'csv',
          className: 'btn-' + vue.variant,
          exportOptions: {
            columns: ':visible'
          },
        },
        {
          extend:'excel',
          exportOptions: {
            columns: ':visible'
          },
          className: 'btn-' + vue.variant,
            customize: function ( xlsx ){

            var sheet = xlsx.xl.worksheets['Parts.xml'];


        }},
        {
          extend: 'pdfHtml5',
          messageTop: function () {
                  return vue.lang.export_label_top + ": " + vue.$store.getters.selectedTreeLibraryItemObject.category;
          },
          className: 'btn-' + vue.variant,
          exportOptions: {
            columns: ':visible'
          },
          orientation: 'landscape',
          pageSize: 'A4',
          download: 'open',
          
          styles: {
            fullWidth: {
                fontSize: 3,
                bold: true,
                alignment: 'right',
                margin: [0,1900,0,80]		
            },
            subheader: {
                fontSize: 4
            },
            superMargin: {
                margin: [20, 0, 40, 0],
                fontSize: 5,
            }
          },
          customize: function ( doc ) {
            

            doc.pageMargins = [10,10,10,10];
            
            doc.styles.title.fontSize = 9;
            doc.defaultStyle.fontSize = 7;
            doc.styles.tableHeader.fontSize = 9;
            doc.content[0].text = doc.content[0].text.trim();
            
            let numberOfHeaders = columnDefs.length;
            
            if ((numberOfHeaders > 10)&&(numberOfHeaders < 15)){
              
              doc.defaultStyle.fontSize = 5;
              doc.styles.tableHeader.fontSize = 7;
            }else if((numberOfHeaders >= 15)&&(numberOfHeaders < 18)){
              
              doc.defaultStyle.fontSize = 5;
              doc.styles.tableHeader.fontSize = 7;
            }else if(numberOfHeaders >= 18){
              
              doc.defaultStyle.fontSize = 3;
              doc.styles.tableHeader.fontSize = 5;
            }
            
          },
          
        },
        {
        text: 'Json',
        exportOptions: {
          columns: ':visible'
        },
        className: 'btn-' + vue.variant,
            action: function ( e, dt, button, config ) {
                var data = dt.buttons.exportData();

                $.fn.dataTable.fileSave(
                    new Blob( [ JSON.stringify( data ) ] ),
                    'Libraries.json'
                );
            }
        },
        {
          text: 'Reload',
          exportOptions: {
            columns: ':visible'
          },
          className: 'btn-' + vue.variant,
          action: function (e, dt, button, config) {

            vue.mainTable.ajax.reload();
          }

        },
        {
          extend: 'colvis',
          className: 'btn-' + vue.variant,
          
        },
      ];

      option.ajax = {
        //url: /*this.server + */"/api/v3/requestmanagement/requests/GetRequests",
        url: /*this.server + */"/api/v3/requestmanagement/requests/GetRequests",
        crossDomain: true,
        type: 'POST',
        dataType: 'json',
        cors: true,
        contentType: 'application/json',
        secure: false,
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'POST, GET, OPTIONS'
        },
        error: function (xhr, ajaxOptions, thrownError) {
          // console.log(xhr)
          // console.log(xhr.status)
          // console.log(thrownError)
          if (xhr.responseJSON.message == "Authorization failure."){
            
            vue.$store.dispatch("logout");
          }
          
        },
        data: function ( json ) {
          

          let categoryId = 1;

          if (vue.categoryId != undefined){

            categoryId = vue.categoryId;
          }

          json.categoryId = categoryId;

          let actions = vue.activeActionIds;

          json.actions = actions;

          

          for (let i = 0, lei = json.columns.length; i < lei; i++){
            json.columns[i].col = i;
          }


          
          return JSON.stringify(json);
        },
        dataFilter: function(data){
          //todo 
          

          
          if (vue.$store.getters.outerData != true){
        
            vue.$store.commit("DELETEALLREQUESTSELECTEDROWS");
            vue.$store.dispatch("setOuterData", false);
          }
         
          y = 0;
          //console.log(data)
            var json = jQuery.parseJSON(data);
          //console.log(json)

          

            let newJson = {
              draw: json.data.draw,
              recordsFiltered: json.data.recordsFiltered,
              recordsTotal: json.data.recordsTotal,
              data: []
            }
            let rows = [];
            vue.lengthMenu = json.data.data.length;
            for (let i = 0, lei = json.data.data.length; i < lei; i++ ) {

              let row = {};
              let objId = {
                requestId: json.data.data[i].requestId,
                partId: json.data.data[i].partId,
                partRevisionId: json.data.data[i].partRevisionId,
                libraryId: json.data.data[i].libraryId,
                libraryRevisionId: json.data.data[i].libraryRevisionId,
                type: json.data.data[i].type,
                                
                value: {
                  display: json.data.data[i].requestId,
                  filter: json.data.data[i].requestId,
                  sort: json.data.data[i].requestId,                  
                }
              };

              let requestId = "col___requestId";
              row[requestId] = objId;

              let objImage = {
                requestId: json.data.data[i].requestId,
                                                
                value: {
                  display: json.data.data[i].requestId,
                  filter: json.data.data[i].requestId,
                  sort: json.data.data[i].requestId
                }
              };

              let image = "col___image";
              row[image] = objImage;

              let objManufacturer = {
                manufacturer: json.data.data[i].manufacturer,
                
                
                
                value: {
                  display: json.data.data[i].manufacturer,
                  filter: json.data.data[i].manufacturer,
                  sort: json.data.data[i].manufacturer
                }
              };

              let manufacturer = "col___manufacturer";
              row[manufacturer] = objManufacturer;

              let objManufacturerPartNumber = {
                manufacturerPartNumber: json.data.data[i].manufacturerPartNumber,
                
                
                value: {
                  display: json.data.data[i].manufacturerPartNumber,
                  filter: json.data.data[i].manufacturerPartNumber,
                  sort: json.data.data[i].manufacturerPartNumber
                }
              };

              let manufacturerPartNumber = "col___manufacturerPartNumber";
              row[manufacturerPartNumber] = objManufacturerPartNumber;

              let objPartNumber = {
                partNumber: json.data.data[i].partNumber,
                
                
                value: {
                  display: json.data.data[i].partNumber,
                  filter: json.data.data[i].partNumber,
                  sort: json.data.data[i].partNumber
                }
              };

              let partNumber = "col___partNumber";
              row[partNumber] = objPartNumber;

              let objLibraryNumber = {
                libraryNumber: json.data.data[i].libraryNumber,
                
                
                value: {
                  display: json.data.data[i].libraryNumber,
                  filter: json.data.data[i].libraryNumber,
                  sort: json.data.data[i].libraryNumber
                }
              };

              let libraryNumber = "col___libraryNumber";
              row[libraryNumber] = objLibraryNumber;

              let objPartRequestNumber = {
                partNumber: json.data.data[i].partRequestNumber,
                
                
                value: {
                  display: json.data.data[i].partRequestNumber,
                  filter: json.data.data[i].partRequestNumber,
                  sort: json.data.data[i].partRequestNumber
                }
              };

              let partRequestNumber = "col___partRequestNumber";
              row[partRequestNumber] = objPartRequestNumber;

              let objDeadline = {
                deadLine: json.data.data[i].deadLine,
                
                
                
                value: {
                  display: json.data.data[i].deadLine,
                  filter: json.data.data[i].deadLine,
                  sort: json.data.data[i].deadLine
                }
              };

              let deadLine = "col___deadLine";
              row[deadLine] = objDeadline;

              let objCreationDate = {
                creationDate: json.data.data[i].creationDate,
                
                
                
                value: {
                  display: json.data.data[i].creationDate,
                  filter: json.data.data[i].creationDate,
                  sort: json.data.data[i].creationDate
                }
              };

              let creationDate = "col___creationDate";
              row[creationDate] = objCreationDate;

              
              let objOwner = {
                owner: json.data.data[i].owner,
                
                
                
                value: {
                  display: json.data.data[i].owner,
                  filter: json.data.data[i].owner,
                  sort: json.data.data[i].owner
                }
              };

              let owner = "col___owner";
              row[owner] = objOwner;

              let objStage = {
                stage: json.data.data[i].stage,
                progress: json.data.data[i].progress,
                
                
                value: {
                  display: json.data.data[i].stage,
                  filter: json.data.data[i].stage,
                  sort: json.data.data[i].stage
                }
              };

              let stage = "col___stage";
              row[stage] = objStage;

              let objPriority = {
                priority: json.data.data[i].priority,
                
                
                
                value: {
                  display: json.data.data[i].priority,
                  filter: json.data.data[i].priority,
                  sort: json.data.data[i].priority
                }
              };

              let priority = "col___priority";
              row[priority] = objPriority;

              let objType = {
                type: json.data.data[i].type,
                libraryType: json.data.data[i].libraryType,
                
                
                value: {
                  display: json.data.data[i].type,
                  filter: json.data.data[i].type,
                  sort: json.data.data[i].type
                }
              };

              let type = "col___type";
              row[type] = objType;

              let objRequestNumber = {
                requestNumber: json.data.data[i].requestNumber,
                
                
                
                value: {
                  display: json.data.data[i].requestNumber,
                  filter: json.data.data[i].requestNumber,
                  sort: json.data.data[i].requestNumber
                }
              };

              let requestNumber = "col___requestNumber";
              row[requestNumber] = objRequestNumber;

              

              rows.push(row);
            }


            newJson.data = rows;

            

            return JSON.stringify(newJson);
          },

        }



          if ($.fn.dataTable.isDataTable('#place'+this._uid)) {
              this.mainTable.destroy();

          }

          this.mainTable = $('#place'+this._uid).DataTable(option);
          
          this.mainTable.column( 0 ).visible( false );

          let el = document.getElementsByClassName("dataTables_processing")[0]
          
         
          el.classList.add("processing-top");
          
          

          //search input change view
          var searchplace = document.getElementById("place"+this._uid+"_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }


          searchplace.firstChild.setAttribute("placeholder", "Enter search words")
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm");
          searchplace.firstChild.addEventListener("input", function(evt){

            _vue.$store.dispatch("setFilteredData", evt.target.value);

          })
          let lengthplace = document.getElementById("place"+this._uid+"_length");
          
          if (lengthplace.firstChild.firstChild != null){
            lengthplace.firstChild.firstChild.nextSibling.setAttribute("class", "form-control form-control-sm select-length");
          }
          
          var stepWait = 0;
          var waitInterval;
          $(".dataTables_filter input")
            .unbind()
            .bind('input', function (e) {
              var item = $(this);
              stepWait = 0;

              if (!waitInterval) {
                waitInterval = setInterval(function () {

                  if (stepWait >= 3) {
                    clearInterval(waitInterval);
                    waitInterval = '';
                    let searchString = $(item).val();
                    _mainTable.search(searchString).draw();
                    stepWait = 0;
                  }
                  stepWait++;
                }, 150);
              }

            });

          let _mainTable = this.mainTable;
          this.mainTable
          .on( 'select', function ( e, dt, type, indexes ) {
              //var rowData = _mainTable.rows( indexes ).data().toArray();
              //var rowData = _mainTable.rows( indexes ).data();
              let rowData = _mainTable.rows('.selected').data();
            
              var count = _mainTable.rows( { selected: true } ).count();
              
              if (_vue.$store.getters.selectedRequestRows.length ==  count - 1 ){
                
              }else{
                
                _vue.$store.commit("DELETEALLREQUESTSELECTEDROWS");
              }
              
              _vue.$store.commit("SETREQUESTSELECTEDROWS", rowData);
              
              

          })
          .on( 'deselect', function ( e, dt, type, indexes ) {

            for (var i = 0, len = indexes.length; i < len; i++){
              var rowData = _mainTable.rows( indexes[i] ).data();

              
              _vue.$store.commit("DELETEREQUESTSELECTEDROWS",rowData[0]);


            }
          });
          
          $('#place'+this._uid+' tbody').on('dblclick', 'tr', function (e) {
            e.stopPropagation() 
            var data = _mainTable.row( this ).data();
            
            _vue.$store.commit("DELETEALLREQUESTSELECTEDROWS");
            _vue.$store.commit("SETREQUESTSELECTEDROWS", [data]);
            _vue.$parent.$parent.$parent.$parent.$parent.$parent.details();
          } );

      
      },
      buildContextMenu(){
        

        var _vue = this;

        
        //context-menu
        var tableid = $("#place" + this._uid);

        $("#place" + this._uid + " tbody tr")
        .on("contextmenu", function(e) {
          
          let tr = $(this).closest('tr');
          let row = _vue.mainTable.row( tr );

          let data = row.data();

          _vue.contextMenu.row = data

          

          //methods in table component
          //var updateUser = _vue.updateUser;
          //var deleteUser = _vue.deleteUser;

          _vue.contextMenu.funcAction = function(_vue, action){

            
            if (action == "Details"){
              _vue.$store.commit("DELETEALLREQUESTSELECTEDROWS");
              _vue.$store.commit("SETREQUESTSELECTEDROWS", [data]);
              _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.details();
            }
            

            return true;
          }

          var height = tableid.height();

          var offsetX = tableid.offset().left;
          var offsetY = tableid.offset().top;

          var top = e.clientY - offsetY + 170;
          var left = e.clientX - offsetX + 10;

          
          $("#context-menu-"+_vue.name).css({
            display: "block",
            top: top,
            left: left
          });
          return false; //blocks default Webbrowser right click menu
        })
        .on("click", function() {
          
          $("context-menu-"+_vue.name).hide();
        });

        $("#context-menu-"+_vue.name + " a").on("click", function() {
          
          $(this)
            .parent()
            .hide();
        });
        document.addEventListener('click', function(e){
          let clickInside = e.target.closest("#context-menu-"+_vue.name);
          
          if(clickInside == null){
            
            let contextMenu = document.getElementById("context-menu-"+_vue.name);
            if (contextMenu != null){
              contextMenu.setAttribute('style', 'display:none');
            }
                                
          }
        });
        //context-menu
      }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .DataTableFilteredOnApiRequestsComponent{
    table{
      font-size: 0.75rem;
      padding: 0px !important;

    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;
      white-space:nowrap;
    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
      position: absolute;
      top: 80px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }
    .processing-top{
      top: 50px;
    }
    

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .dataTables_length{
      margin-left: 20px;
      width: 200px;
      float: left;
    }
    .dataTables_length label{
      display: inline-flex;
    }
    .select-length{
      padding: 0.1rem;
      margin-left:10px;
      margin-right:10px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      //margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
      width: 350px;
      float: left;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image-category{
      max-width: 40px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      
    }
    .badge{
      margin-right: 1px;
      
      margin-bottom: 2px;
    }
    .badges{
      margin-top: 3px;
      margin-bottom: 2px;
    }
    .image-svg{
      max-width: 30px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-right: 3px;
      margin-bottom: 3px;
      background-color: white;
      padding: 2px;
    }
    .progress{
      margin: 5px;
      margin-top: 8px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/DataTableFilteredOnApiRequestsComponent.vue